/* eslint-disable import/no-cycle */
import { action, observable } from 'mobx';
import { navigate } from 'gatsby-plugin-intl';
import AuthService, { logout } from '../services/AuthService';
import HelperStore from './HelperStore';
import RootStore from '.';

class AuthStore {
  @observable
  public isLoggedIn = false;

  @observable
  public userDetails = new HelperStore(AuthService.login, [], []);

  @observable
  private rootStore: RootStore;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }

  @action
  public async login(username: string, password: string): Promise<boolean> {
    this.userDetails.setDataToSend = [username, password];
    await this.userDetails.execute();
    if (!this.userDetails.errorMessage) {
      this.isLoggedIn = true;
      navigate('/');
    }
    return this.isLoggedIn;
  }

  @action
  public checkUserLogin(): void {
    this.isLoggedIn = AuthService.checkUserLogin();
  }

  @action
  public logout(): void {
    logout();
    navigate('/login');
    this.checkUserLogin();
    this.userDetails.reset();
  }
}

export default AuthStore;
